<template>
    <div>
        <div name="sortHeader" style="width:100%; height: 34px; line-height: 30px;padding-left : 10px; font-size: 14px; background-color: #EFEFEF;">
            排序字段
            <span v-if="!viewMode" class="ml10">
                <el-link type="danger" v-if="userMode == 0" class="ml20" style="padding-bottom:2px;font-size:13px;" size="mini" @click="clearSortFields()">清除所有字段</el-link>
                <el-link type="primary" v-if="userMode == 0" class="ml20 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" @click="addSortField()">+ 追加字段</el-link>
            </span>
            <span v-if="userMode ==2 && !viewMode" class="fr mr5">
                <span v-if="showExtBtns" class="fr ml30 mr5">
                    <el-button v-if="custSavable && onSaveCustConf != null" @click="handleSaveCustConf()" size="mini" icon="el-icon-document-checked" style="margin-top: 1px;" title="保存调整">保存调整</el-button>
                    <el-divider v-if="custSavable && onSaveCustConf != null" direction="vertical"></el-divider>
                    <el-button @click="handleConfirm()" size="mini" icon="el-icon-check" style="margin-top: 1px;" title="应用调整">应用</el-button>
                    <a @click="handleClose()" title="取消/关闭" class="ml20 mr5" style="width:30px;height:30px;text-align: center;vertical-align: middle">
                        <i class="el-icon-close" style="font-size : 18px; "></i>
                    </a>
                </span>
            </span>
            <span class="fr mr5" v-if="userMode == 0 && !viewMode">
                <span>
                    <el-input size="mini" v-model="instantKeyword" class="mr10" placeholder="输入 过滤文本" style="width:100px;" clearable @change="filterList"></el-input>
                    <el-divider direction="vertical"></el-divider>
                    <span v-if="forHisQry">
                        <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-notebook-2" @click="appendFromCols()">从表列选择</el-link>
                        <el-divider direction="vertical"></el-divider>
                    </span>
                </span>
                <span v-if="!uiUnion">
                    <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-document" title="meta sortFields" @click="inputJsonConf()">输入json配置</el-link>
                </span>
            </span>
        </div>
        <el-form name="gridTableWrapper" ref="gridForm" :model="gridForm" class="sort-conf-form">
            <el-table ref="gridTable" :data="gridForm.fieldConfRows" v-row-draggable="makeDragCtxData()" :row-class-name="getSortRowClassName" :row-key="rowItemKey" :height="gridHeight" stripe highlight-current-row size="mini"
                      style="width: 100%;">
                <el-table-column label="序号" width="60" align="center" type="index" fixed></el-table-column>
                <el-table-column v-if="userMode == 0" label="代码" width="120">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].code'">
                            <el-input maxlength="30" class="sort-code" v-model="scope.row.code" size="mini"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="名称" width="100">
                    <template slot-scope="scope">
                        <div class="text">
                            <el-form-item style="margin-bottom: 0" v-if="userMode == 0" :prop="'fieldConfRows[' + scope.$index + '].label'">
                                <el-input maxlength="20" class="sort-label" v-model="scope.row.label" size="mini"/>
                            </el-form-item>
                            <div v-else="">{{ scope.row.label }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="排序" width="160" align="center">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].order'">
                            <el-switch style="font-size:12px;" size="mini" v-model="scope.row.order" active-value="desc" inactive-value="asc" active-color="#00438a" inactive-color="#333333" active-text="降序" inactive-text="升序"></el-switch>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="启用" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" v-model="scope.row.enabled"/>
                    </template>
                </el-table-column>
                <el-table-column v-if="!viewMode" label="操作/顺序" width="140" align="center">
                    <template slot-scope="scope">
                        <div>
                            <i class="icon iconfont icon-arrow-top pr10" style="cursor:pointer;" @click="moveSortField(scope.$index, 'prev')"></i>
                            <i class="icon iconfont icon-arrow-bottom pr10" style="cursor:pointer;" @click="moveSortField(scope.$index, 'next')"></i>
                            <i v-if="userMode == 0" class="icon iconfont el-icon-delete pl10 pr10" style="cursor:pointer;color:orange" @click="delSortField(scope.$index)"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
</template>

<script>
    import {Utils, $, Jqext} from '../../app.base'
    import {Vue, MsgBox, VRowId, getColDefAlign, getColDefFormat, calcDomHeight, getElTableHeight, fixElTableFixedHeight} from '../../app.vues'
    import SwbPropEditor from '../ctrl/PropEditor.vue';
    import SwbDtPopover from '../ctrl/DtPopover.vue';

    import SwbCodeEditor from '../ctrl/CodeEditor.vue'
    import {showDbColSelectDlg} from './dialog';

    Vue.regist(SwbCodeEditor);

    let Toast = Jqext.Toast;

    function isValidSortField(sortField) {
        let valid = true;
        if (sortField == null) {
            valid = false;
        } else {
            if (sortField.code == null || sortField.code.trim() == '') {
                valid = false;
            } else if (sortField.label == null || sortField.label.trim() == '') {
                valid = false;
            } else if (sortField.order == null || sortField.order.trim() == '') {
                valid = false;
            }
        }
        return valid;
    }

    export function extractCustSortFieldInfo(sortField) {
        return sortField == null ? null : {
            code: sortField.code,
            //
            order: sortField.order || 'desc',
            enabled: sortField.enabled || false
        };
    }

    //保留性地合并数组元素 arr1st <= arr2nd（保留arr1st中元素的属性值）
    export function reserveMergeSortArray(arr1st, arr2nd, keyProp = 'id') {
        arr1st = arr1st || [];
        arr2nd = arr2nd || [];
        let arr2Map = arr2nd.toMap(keyProp);
        //去除不存在的
        for (let i = arr1st.length - 1; i >= 0; i--) {
            let item1st = arr1st[i] || {};
            let keyValue = item1st[keyProp];
            if (typeof arr2Map[keyValue] == 'undefined') {
                arr1st.removeAt(i);//已不存在删除之
                console.log('已去除不再有效的字段：' + keyProp + ' = ' + keyValue);
            }
        }
        let arrNew = [];
        for (let i = 0, c = arr1st.length; i < c; i++) {
            let item1st = extractCustSortFieldInfo(arr1st[i]) || {};
            let keyValue = item1st[keyProp];
            let item2nd = Utils.merge({}, arr2Map[keyValue]);//copy
            delete arr2Map[keyValue]; //去掉
            arrNew[i] = Utils.merge(item2nd, item1st); // item2nd + item1st
        }
        //加上剩余地
        for (let keyValue in arr2Map) {
            arrNew.push(arr2Map[keyValue]);
        }
        //
        return arrNew;
    }

    //--------------------------------------------------
    const confHeaderHeight = 34;
    export default {
        components: {SwbPropEditor, SwbDtPopover},
        name: 'swb-sort-field-conf',
        desc: '查询字段信息配置',
        //
        props: {
            viewMode: {
                type: Boolean,
                default: false
            },
            userMode: {//用户模式：0: 开发模式, 1: 运营模式，2：用户模式
                type: Number,
                default: 2
            },
            //是否为历史查询
            forHisQry: {
                type: Boolean,
                default: false
            },
            //历史表名（仅供历史查询设计用）
            hisTblName: {
                type: String,
                default: null
            },
            showExtBtns: {//是否显示扩展按钮
                type: Boolean,
                default: false
            },
            uiUnion: {//是否与QueryFieldConf联合ui模式
                type: Boolean,
                default: false
            },
            custSavable: {//自定义信息是否可以保存
                type: Boolean,
                default: false
            },
            onSaveCustConf: {//保存自定义调整处理函数
                type: Function,
                default: null
            },
            onConfirm: {//应用按钮处理函数
                type: Function,
                default: null
            },
            onClose: {//关闭按钮处理函数
                type: Function,
                default: null
            },
            metaSortFields: {
                type: Array,
                default: null
            },
            custSortFields: {//code => order, enabled
                type: Array,
                default: null
            },
            height: {//指定的高度
                default: 0
            }
        },
        //
        data() {
            return {
                theVRowId: null,
                rowItemKey: 'code',
                //
                instantKeyword: '', //及时关键字
                delayedKeyword: '', //延迟关键字
                //最大的高度
                maxHeight: 0,
                //
                gridHeight: '100%',
                //
                tooltipDelayMs: 1000,
                //
                metaSortFieldsInner: [],
                custSortFieldsInner: [],
                //
                gridForm: {
                    fieldConfRows: []
                }
            };
        },
        watch: {
            userMode(newVal, oldVal) {
                this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'code';
                //
                this.init();
            },
            forHisQry(newVal, oldVal) {
                this.init();
            },
            metaSortFields(newVal, oldVal) {
                this.metaSortFieldsInner = Utils.merge([], this.metaSortFields);
                this.custSortFieldsInner = [];
                //
                this.init();
            },
            custSortFields(newVal, oldVal) {
                this.custSortFieldsInner = Utils.merge([], this.custSortFields);
                //
                this.init();
            },
            height(newVal, oldVal) {
                this.setHeights();
            }
        },
        //
        created() {
            this.theVRowId = VRowId.newOne().name('_row_id_');
            //
            this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'code';
            //
            this.metaSortFieldsInner = Utils.merge([], this.metaSortFields);
            this.custSortFieldsInner = Utils.merge([], this.custSortFields);
        },
        //
        mounted() {
            let thisEl = $(this.$el);
            //
            this.gridTableWrapper = thisEl.find('>[name="gridTableWrapper"]');
            this.gridTable = this.$refs['gridTable'];
            //
            this.init();
            //
            this.setHeights();
        },
        beforeDestroy() {
            this.gridTableWrapper = null;
            this.gridTable = null;
        },
        //
        methods: {
            //返回推拽信息（注意绑定表达式写法：v-row-draggable="makeDragCtxData()"）
            makeDragCtxData() {
                return {
                    //函数调用上下文
                    context: this,
                    //数据提供者（基于 context 调用，可以使用 this）
                    provider: function () {
                        //返回 null 或 false 代表不允许拖拽
                        return this.gridForm.fieldConfRows || [];
                    },
                    //数据变更回调函数（基于 context 调用，可以使用 this）
                    callback: function (dataList, newIndex) {
                        //console.log(dataList);
                        //console.log('条目已经移动到第 ' + (newIndex + 1) + ' 行');
                        this.$set(this.gridForm, 'fieldConfRows', dataList);
                        //
                        this.$nextTick(function () {
                            this.gridTable.setCurrentRow(dataList[newIndex]);
                        });
                    }
                };
            },
            setHeights() {
                let gridHeight = this.gridHeight = this.getGridHeight();
                this.gridTableWrapper.height(gridHeight);
                //
                this.gridTable.doLayout();
            },
            setMaxHeight(maxHeight) {
                this.maxHeight = maxHeight || 0;
                //
                this.setHeights();
            },
            getGridHeight() {
                let extraHeight = confHeaderHeight; //头部固定高度
                let gridTable = this.gridTable;
                return this.calcGridHeight(gridTable, this.height, this.maxHeight, extraHeight);
            },
            calcGridHeight(gridTable, height, maxHeight, extraHeight = 0) {
                height = height || 0;
                let heightGiven = typeof height == 'number' && height > 0;
                if (heightGiven) {
                    height = Math.max(height, extraHeight);
                }
                maxHeight = maxHeight || 0;
                let gridHeight = height || '100%';
                let needHeight = getElTableHeight(gridTable);
                if (maxHeight > 0) {//限定最大高度
                    maxHeight = Math.max(maxHeight, extraHeight);
                    if (needHeight + extraHeight > maxHeight) {//不超过最大高度
                        gridHeight = maxHeight - extraHeight;
                    } else {
                        let adjusted = false;
                        if (heightGiven) {//同时指定了高度
                            height = Math.min(height, maxHeight);
                            if (needHeight + extraHeight < height) {//不低于指定高度
                                gridHeight = height - extraHeight;
                                adjusted = true;
                            }
                        }
                        if (!adjusted) {//未指定高度，自动伸缩
                            gridHeight = needHeight;
                        }
                    }
                } else {//仅指定了高度
                    if (heightGiven) {
                        gridHeight = height - extraHeight;
                    }
                }
                return gridHeight;
            },
            getSortRowClassName({row, rowIndex}) {
                let classNames = [];
                //
                if (this.userMode == 0) {//增加过滤隐藏class
                    let keyword = (this.delayedKeyword || '').trim();
                    if (keyword.length > 0) {
                        //忽略大小写匹配
                        keyword = keyword.toLowerCase();

                        let filterOk = false;
                        let tempStr = row.label || '';
                        if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                            filterOk = true;
                        }

                        if (!filterOk) {
                            tempStr = row.code || '';
                            if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                                filterOk = true;
                            }
                        }
                        //
                        if (!filterOk) {
                            classNames.push('filter-hidden');
                        }
                    }
                }

                if (!row.enabled) {
                    classNames.push('disabled-field');
                }
                //
                if (row.code == null || row.code.trim() == '') {
                    classNames.push('invalid-code');
                }
                if (row.label == null || row.label.trim() == '') {
                    classNames.push('invalid-label');
                }
                //
                return classNames.join(' ');
            },
            init(metaSortFields) {
                if (metaSortFields != null) {//完全重新替换
                    this.metaSortFieldsInner = Utils.merge([], metaSortFields);
                    this.custSortFieldsInner = [];//清空
                } else if (this.userMode < 2) {//非用户模式忽略自定义
                    this.custSortFieldsInner = [];
                }
                let fieldConfRows = this.userMode == 2 ? reserveMergeSortArray(this.custSortFieldsInner, this.metaSortFieldsInner, 'code') : this.metaSortFieldsInner;
                //
                if (this.rowItemKey == this.theVRowId.name()) {
                    this.theVRowId.setIds(fieldConfRows);
                } else {
                    this.theVRowId.delIds(fieldConfRows);
                }
                this.gridForm.fieldConfRows = fieldConfRows;
                //
                let self = this;
                setTimeout(function () {
                    if (self.gridTable != null) {
                        self.gridTable.doLayout();
                    }
                }, 500);
            },
            //
            clearSortFields() {
                if (this.userMode > 0) {
                    return;
                }
                //
                this.init([]);
            },
            addSortField() {
                if (this.userMode > 0) {
                    return;
                }
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let sortField = {
                    code: '',
                    label: '',
                    order: 'desc',
                    enabled: true
                };
                //
                this.theVRowId.setId(sortField);
                //
                fieldConfRows.append(sortField);
                //
                this.init(fieldConfRows);
            },
            delSortField(index) {
                if (this.userMode > 0) {
                    return;
                }
                //
                let fieldConfRows = this.gridForm.fieldConfRows.clone();
                fieldConfRows.removeAt(index);
                this.gridForm.fieldConfRows = fieldConfRows;
            },
            moveSortField(index, where) {
                let fieldConfRows = this.gridForm.fieldConfRows.clone();
                fieldConfRows.move([index], where);
                this.gridForm.fieldConfRows = fieldConfRows;
            },
            filterList() {
                //利用change事件避免频繁模型的值频繁触发事件
                this.delayedKeyword = this.instantKeyword;
            },
            appendByCols(selCols) {
                if (this.userMode > 0) {
                    return;
                }
                //
                selCols = selCols || [];
                if (selCols.length > 0) {
                    let fieldConfRows = this.gridForm.fieldConfRows;
                    for (let i = 0, c = selCols.length; i < c; i++) {
                        let tmpCol = selCols[i];
                        let sortField = {
                            code: tmpCol.columnName,
                            label: tmpCol.comment,
                            order: 'desc',
                            enabled: true
                        };
                        //
                        //
                        this.theVRowId.setId(sortField);
                        //
                        fieldConfRows.append(sortField);
                    }
                    //
                    this.init(fieldConfRows);
                }
            },
            appendFromCols() {
                let hisTblName = this.hisTblName;
                if (Utils.isNoB(hisTblName)) {
                    Toast.show('未指定库表，操作无法继续', 5000, 'warning');
                    return;
                }
                //
                let iniSelected = [];
                //当前存在的
                let fieldConfRows = this.gridForm.fieldConfRows;
                fieldConfRows.forEach(function (confRow) {
                    let code = (confRow.code || '').trim();
                    if (code) {
                        iniSelected.push(code);
                    }
                });
                //
                let self = this;
                showDbColSelectDlg({
                    tableName: hisTblName,
                    iniSelected: iniSelected
                }, function (selectedCols) {
                    console.log(selectedCols);
                    self.appendByCols(selectedCols);
                });
            },
            inputJsonConf() {
                let metaFields = this.getMetaSortFields() || [];
                //
                let self = this;
                Vue.$showDialog({
                    title: '输入json配置 - meta sortFields',
                    width: 800,//80%
                    height: -100,//80%
                    showCloseBtn: false,
                    centerButtons: true,
                    template: '<swb-code-editor style="width:740px;height:100%;margin:0;" language="json" v-model="content" ></swb-code-editor>',
                    data: {content: JSON.format(metaFields)},

                    okClicked: function () {
                        let jsonModel = (this.content || '').trim();
                        console.debug(jsonModel);
                        let metaFields = [];
                        try {
                            metaFields = JSON.decode(jsonModel)
                        } catch (ex) {
                            //console.warn(ex);
                        }
                        if (metaFields.length < 1) {
                            this.$message({
                                type: 'warning',
                                message: 'json 数组模型无效'
                            });
                            return false;
                        }
                        //
                        self.resetMetaSortFields(metaFields);
                    }
                });
            },
            handleSaveCustConf() {
                if (this.onSaveCustConf) {
                    this.onSaveCustConf();
                } else {
                    console.warn('未设置 onSaveCustConf 事件处理函数')
                }
            },
            handleConfirm() {
                if (this.onConfirm) {
                    this.onConfirm();
                } else {
                    console.warn('未设置 onConfirm 事件处理函数')
                }
            },
            //
            handleClose() {
                if (this.onClose) {
                    this.onClose();
                } else {
                    console.warn('未设置 onClose 事件处理函数')
                }
            },
            //===================================== 公开方法 =======================================
            //重置元列列表
            resetMetaSortFields(metaSortFields = []) {
                this.init(metaSortFields);
            },
            //获取自定义配置（仅包含自定义部分）
            getCustSortFields(debugOnly) {
                let fieldConfRows = this.gridForm.fieldConfRows;
                //
                fieldConfRows = Utils.merge([], fieldConfRows);
                //过滤无效的
                fieldConfRows = fieldConfRows.filter(function (fieldConf) {
                    return isValidSortField(fieldConf);
                });
                //
                return this.userMode == 2 || debugOnly ? fieldConfRows.map(function (item) {
                    return extractCustSortFieldInfo(item);
                }) : [];
            },
            //
            getMetaSortFields() {
                let fieldConfRows = this.gridForm.fieldConfRows;
                //
                fieldConfRows = Utils.merge([], fieldConfRows);
                //过滤无效的
                fieldConfRows = fieldConfRows.filter(function (fieldConf) {
                    return isValidSortField(fieldConf);
                });
                //数据调整
                let theVRowId = this.theVRowId;
                theVRowId.delIds(fieldConfRows);
                //
                return fieldConfRows;
            }
        }
    }
</script>

<style>
    .sort-conf-form .el-table table tbody tr.filter-hidden {
        display: none;
    }

    .sort-conf-form .el-table__body tr.disabled-field > td,
    .sort-conf-form .el-table__body tr.disabled-field > td input {
        font-style: italic;
        color: #AAAAAA !important;
    }

    .sort-conf-form .el-table__body tr.invalid-code > td .sort-code input {
        border: 1px dashed red;
    }

    .sort-conf-form .el-table__body tr.invalid-label > td .sort-label input {
        border: 1px dashed red;
    }
</style>




// WEBPACK FOOTER //
// src/compo/query/SortFieldConf.vue